import { CheckCircle2, XCircle } from "lucide-react";

export const QualifyBadge = ({ qualifies, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-1 px-2 py-0.5 rounded border text-[11px] font-mono font-semibold tracking-wider ${
      qualifies
        ? "bg-emerald-500/15 text-emerald-300 border-emerald-500/30"
        : "bg-rose-500/15 text-rose-300 border-rose-500/30"
    }`}
  >
    {qualifies ? <CheckCircle2 className="h-3 w-3" /> : <XCircle className="h-3 w-3" />}
    {qualifies ? "PREFERRED BETTING RACE" : "NOT A PREFERRED BETTING RACE"}
  </span>
);

export const EligibilityChecklist = ({ checks, qualifies }) => (
  <div className="panel p-5" data-testid="race-detail-eligibility-checklist">
    <div className="flex items-center justify-between mb-4">
      <div className="eyebrow">Selection Rules Audit</div>
      <QualifyBadge qualifies={qualifies} testId="race-detail-qualify-badge" />
    </div>
    {checks.length === 0 && <p className="text-sm text-slate-500">No selection rules active.</p>}
    <ul className="grid sm:grid-cols-2 lg:grid-cols-5 gap-3">
      {checks.map((c) => (
        <li key={c.rule} className="flex items-start gap-3" data-testid={`rule-check-${c.rule}`}>
          {c.passed ? (
            <CheckCircle2 className="h-4 w-4 mt-0.5 text-emerald-400 shrink-0" />
          ) : (
            <XCircle className="h-4 w-4 mt-0.5 text-rose-400 shrink-0" />
          )}
          <div className="min-w-0">
            <div className="text-sm text-slate-200">{c.label}</div>
            <div className="text-xs num text-slate-500">Actual: {c.value}</div>
          </div>
        </li>
      ))}
    </ul>
  </div>
);
